import { apiClient } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

export interface UploadAssetRequest {
  contestId: string;
  assetType: 'badge' | 'background' | 'rules' | 'submit-view';
  imageData: string; // Base64 data URL
}

export interface UploadAssetResponse {
  imageUrl: string;
  assetType: string;
  contestId: string;
  message: string;
}

export const uploadAsset = async (data: UploadAssetRequest): Promise<UploadAssetResponse> => {
  // Using type assertion to bypass strict path typing since this endpoint isn't in generated types yet
  const response = await (apiClient.post as any)('/api/admin/squares/upload-asset', data);
  return response as UploadAssetResponse;
};

export const useUploadAssetMutation = () => {
  return useMutation({
    mutationFn: uploadAsset,
    onSuccess: _data => {
      toast.success('Image uploaded successfully');
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.error || 'Failed to upload image';
      toast.error(errorMessage);
    },
  });
};
